import { useParams, useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
   useGetProviderByIdQuery,
   useUpdateProviderMutation,
   providerApi,
} from '../../Redux/Service/ProviderApi';
import { toast } from 'react-toastify';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StyledDashboardLayout from '../style';
import ServiceProviderForm from './ServiceProviderForm';
import { handleApiError } from '../../utils/apiErrorHandler';

function ServiceProviderEdit() {
   const { id } = useParams();
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const { data, isLoading, error } = useGetProviderByIdQuery(id);
   const [updateProvider] = useUpdateProviderMutation();

   if (isLoading) return <div className="m-3">Loading...</div>;
   if (error) return <div className="m-3">Failed to load provider</div>;

   const provider = data.response[0];

   // Parse existing phone number to extract country code and phone number
   // Expected format: "(+91) 1234567890"
   const parsePhoneNumber = (phoneNo) => {
      const match = phoneNo.match(/^\((\+\d{1,3})\)\s(\d{10})$/);
      if (match) {
         return {
            countryCode: match[1],
            phoneNumber: match[2],
         };
      }
      return {
         countryCode: '+91',
         phoneNumber: '',
      };
   };

   const parsedPhone = parsePhoneNumber(provider.phoneNo);

   const handleSubmit = async (values, { setSubmitting, setFieldValue }) => {
      try {
         setSubmitting(true);
         const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
         const maxFileSize = 2 * 1024 * 1024; // 2MB

         if (values.logo && !validImageTypes.includes(values?.logo?.type)) {
            console.log("null from first");
            toast.error('Only JPEG, JPG, and PNG files are allowed for signature');
            setFieldValue('logo', null);
            return;
         }

         if (values.logo && !(values?.logo?.size <= maxFileSize)) {
            console.log("null from second");
            toast.error('File size should be less than 2MB');
            setFieldValue('logo', null);
            return;
         }

         const formData = new FormData();

         // Reconstruct phone number in the format expected by API: (+91) 1234567890
         const phoneNo = `(${values.countryCode}) ${values.phoneNumber}`;

         Object.entries(values).forEach(([k, v]) => {
            if (v !== null && v !== undefined && k !== 'countryCode' && k !== 'phoneNumber') {
               formData.append(k, v);
            }
         });

         // Add the reconstructed phone number
         formData.append('phoneNo', phoneNo);

         const res = await updateProvider({ id, formData }).unwrap();
         toast.success(res.message);

         // Invalidate both queries to fetch fresh data
         dispatch(providerApi.util.invalidateTags(['ServiceProvider']));

         navigate('/service-providers');
      } catch (error) {
         handleApiError(error);
      } finally {
         setSubmitting(false);
      }
   };

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header d-flex justify-content-between m-3">
               <h1>Edit Service Provider</h1>
               <Link to="/service-providers" className="btn addBtn">
                  <ArrowBackIcon /> Back
               </Link>
            </div>

            <div className="card customCard p-3 m-3">
               <ServiceProviderForm
                  initialValues={{
                     name: provider.name,
                     email: provider.email,
                     countryCode: parsedPhone.countryCode,
                     phoneNumber: parsedPhone.phoneNumber,
                     address: provider.address,
                     status: provider.status,
                     logo: null,
                  }}
                  onSubmit={handleSubmit}
                  submitLabel="Update"
                  logo={provider.logo}
               />
            </div>
         </div>
      </StyledDashboardLayout>
   );
}

export default ServiceProviderEdit;
